import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { Button, Menu, MenuItem } from '@material-ui/core';

/*
  Taken from MUI's basic menu button demo: https://codesandbox.io/p/sandbox/keen-cdn-y9rkr7?file=%2Fsrc%2FDemo.js%3A27%2C12
*/
export const GridDownloadButton = props => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    id: "basic-button",
    "aria-controls": open ? 'basic-menu' : undefined,
    "aria-haspopup": "true",
    "aria-expanded": open ? 'true' : undefined,
    onClick: handleClick,
    style: props.style
  }, "Download"), /*#__PURE__*/React.createElement(Menu, {
    id: "basic-menu",
    anchorEl: anchorEl,
    open: open,
    onClose: handleClose,
    MenuListProps: {
      'aria-labelledby': 'basic-button'
    }
  }, props.includeCSV && /*#__PURE__*/React.createElement(MenuItem, {
    onClick: () => {
      var _props$gridApi, _props$getCsvExportPa;

      return (_props$gridApi = props.gridApi) === null || _props$gridApi === void 0 ? void 0 : _props$gridApi.exportDataAsCsv(_objectSpread({
        allColumns: true
      }, (_props$getCsvExportPa = props.getCsvExportParams) === null || _props$getCsvExportPa === void 0 ? void 0 : _props$getCsvExportPa.call(props, props.gridApi)));
    }
  }, "Save as CSV"), props.includeExcel && /*#__PURE__*/React.createElement(MenuItem, {
    onClick: () => {
      var _props$gridApi2, _props$getExcelExport;

      return (_props$gridApi2 = props.gridApi) === null || _props$gridApi2 === void 0 ? void 0 : _props$gridApi2.exportDataAsExcel(_objectSpread({
        allColumns: true
      }, (_props$getExcelExport = props.getExcelExportParams) === null || _props$getExcelExport === void 0 ? void 0 : _props$getExcelExport.call(props, props.gridApi)));
    }
  }, "Save as Excel")));
};
export default GridDownloadButton;